import { render } from "./DateInput.vue?vue&type=template&id=54f746ca"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"

import "./DateInput.vue?vue&type=style&index=0&id=54f746ca&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__